module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('header', [_c('h1', [_vm._v("\n      Maxence"), _c('br'), _vm._v("\n      Aici\n    ")]), _vm._v(" "), _c('p', [_vm._v("maker - software engineering, design, video")])]), _vm._v(" "), _c('main', [_c('a', {
    attrs: {
      "href": "/files/Maxence_Aici_CV.pdf"
    }
  }, [_vm._v("cv")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://github.com/mininao"
    }
  }, [_vm._v("github")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:maxence@aici.me"
    }
  }, [_vm._v("email")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-71324c62","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 6
// module chunks = 1